// tslint:disable
/**
 * Notification api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CompanySettings } from '../models';
import { Tokens } from '../models';
/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteNotificationCompanySettings.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling deleteNotificationCompanySettings.');
            }
            const localVarPath = `/company/{id}/notification-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {CompanySettings} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', body: CompanySettings, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editNotificationCompanySettings.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling editNotificationCompanySettings.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editNotificationCompanySettings.');
            }
            const localVarPath = `/company/{id}/notification-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getNotificationCompanySettings.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling getNotificationCompanySettings.');
            }
            const localVarPath = `/company/{id}/notification-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTokens(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getNotificationTokens.');
            }
            const localVarPath = `/company/{id}/notification-tokens`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).deleteNotificationCompanySettings(id, type, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {CompanySettings} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', body: CompanySettings, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanySettings> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).editNotificationCompanySettings(id, type, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanySettings> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).getNotificationCompanySettings(id, type, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTokens(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tokens> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).getNotificationTokens(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any) {
            return CompanyApiFp(configuration).deleteNotificationCompanySettings(id, type, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {CompanySettings} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', body: CompanySettings, options?: any) {
            return CompanyApiFp(configuration).editNotificationCompanySettings(id, type, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any) {
            return CompanyApiFp(configuration).getNotificationCompanySettings(id, type, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTokens(id: string, options?: any) {
            return CompanyApiFp(configuration).getNotificationTokens(id, options)(axios, basePath);
        },
    };
};

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any) {
        return CompanyApiFp(this.configuration).deleteNotificationCompanySettings(id, type, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
     * @param {CompanySettings} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public editNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', body: CompanySettings, options?: any) {
        return CompanyApiFp(this.configuration).editNotificationCompanySettings(id, type, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public getNotificationCompanySettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any) {
        return CompanyApiFp(this.configuration).getNotificationCompanySettings(id, type, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public getNotificationTokens(id: string, options?: any) {
        return CompanyApiFp(this.configuration).getNotificationTokens(id, options)(this.axios, this.basePath);
    }

}
